@if (selectedForm && selectedForm.pages.length > 1) {
  <div class="progress-container">
    
    <!-- Desktop: Full stepper -->
    @if (stepperOrientation === 'horizontal') {
      <mat-stepper 
        #stepper
        [orientation]="stepperOrientation"
        [selectedIndex]="currentStepIndex"
        [labelPosition]="'bottom'"
        class="assessment-stepper">
        
        @for (page of selectedForm.pages; track $index) {
          <mat-step 
            [label]="getStepLabel(page)"
            [completed]="isStepCompleted($index)"
            [editable]="true"
            [state]="$index === currentStepIndex ? 'number' : ($index < currentStepIndex ? 'done' : 'number')">
            

          </mat-step>
        }
        
        <!-- Custom icons for different states -->
        <ng-template matStepperIcon="done">
          <mat-icon>check</mat-icon>
        </ng-template>
        
      </mat-stepper>
    }
    
    <!-- Mobile: Compact current step indicator -->
    @else {
      <div class="mobile-step-indicator">
        <div class="step-info">
          <div class="step-icon">
            @if (currentStepIndex < selectedForm.pages.length) {
              @if (isStepCompleted(currentStepIndex)) {
                <mat-icon>check</mat-icon>
              } @else {
                <span>{{ currentStepIndex + 1 }} of {{ selectedForm.pages.length }}</span>
              }
            }
          </div>
          <div class="step-content">
            <div class="step-title">{{ getStepLabel(selectedForm.pages[currentStepIndex]) }}</div>
          </div>
        </div>
        <div class="progress-bar">
          <div 
            class="progress-fill" 
            [style.width.%]="((currentStepIndex + 1) / selectedForm.pages.length) * 100">
          </div>
        </div>
      </div>
    }
    
    @if (showOptions) {
      <div class="options-container">
        <button 
          mat-icon-button 
          class="options-button"
          matTooltip="manage account"
          (click)="optionsClicked()">
          <mat-icon>more_vert</mat-icon>
        </button>
             
      </div>
    }
  </div>
}